import { l as localizationInterpolation } from "../common/localization.js";
function useFederationLocalization(options) {
  const loadingMap = /* @__PURE__ */ new Map();
  const fragmentLocalization = {
    getDir,
    getLanguage,
    t,
    onLanguageChange,
    interpolation: localizationInterpolation
  };
  const languageEventTarget = new EventTarget();
  const namespace = `fragment-${options.fragmentName}`;
  let language;
  let liveComponents = 0;
  return {
    fragmentLocalization,
    setLocalization,
    subscribe
  };
  function t(key, tOptions) {
    if (!options.i18next) {
      throw new Error("i18next is not configured in the root");
    }
    return options.i18next.t(key, { ...tOptions, ns: namespace });
  }
  function getDir() {
    if (!options.i18next) {
      throw new Error("i18next is not configured in the root");
    }
    return options.i18next.dir(language);
  }
  function getLanguage() {
    if (!language) {
      throw new Error("i18next is not configured in the root");
    }
    return language;
  }
  function onLanguageChange(callback) {
    if (!options.i18next) {
      throw new Error("i18next is not configured in the root");
    }
    const onChanged = () => callback(getLanguage());
    languageEventTarget.addEventListener("changed", onChanged);
    return () => languageEventTarget.removeEventListener("changed", onChanged);
  }
  function subscribe() {
    liveComponents++;
    return () => liveComponents--;
  }
  async function setLocalization() {
    if (!options.i18next) {
      return;
    }
    if (liveComponents === 0) {
      return;
    }
    const newLanguage = options.i18next.language;
    if (!loadingMap.has(newLanguage)) {
      const { languages } = options.i18next;
      const promise = loadLocalization(newLanguage, languages).catch((error) => {
        loadingMap.delete(newLanguage);
        throw error;
      });
      loadingMap.set(newLanguage, promise);
    }
    const existingLanguage = await loadingMap.get(newLanguage);
    if (existingLanguage) {
      setLanguage(existingLanguage);
    }
  }
  function setLanguage(newLanguage) {
    language = newLanguage;
    languageEventTarget.dispatchEvent(new Event("changed"));
  }
  async function loadLocalization(newLanguage, languages) {
    const result = await options.fragmentNetwork.loadLocalizationResources(languages);
    if (result) {
      options.i18next.addResourceBundle(newLanguage, namespace, result.resources);
      return result.language;
    }
  }
}
export {
  useFederationLocalization as u
};
//# sourceMappingURL=fragmentLocalization.js.map
